import React from 'react';
import type { RenderLeftCellProps } from '../../types';
import SourceTable from '../SourceTable';
import Loading from '@/pages/intelligence/components/Loading';

export default function RenderLeftCell(props: RenderLeftCellProps) {
  const {
    gamesAllList,
    noSearchResultTips,
    entityType,
    checkedEntitiesKeys,
    entityKey,
    isMoreLoading,
    checkedEntities,
    setCheckedEntities,
    handleLoadMore,
    entityRenderer,
    chooseUpNum = 1000,
    hasShortCut,
    isDisabled,
    disabledMsg,
    showEntity,
  } = props;

  const handleCheckedEntitiesKeysChange = (payload: string[], e: any) => {
    // 勾选事件
    if (e.checked) {
      // 超出1000,禁止再选，并提示
      if (Array.isArray(payload) && payload?.length <= chooseUpNum) {
        if (payload?.includes(e.recordKey)) {
          const gamesAllListAddList = [e.record, ...checkedEntities];
          setCheckedEntities(gamesAllListAddList);
        }
      }
    } else {
      const checkedEntitiesTemp = checkedEntities?.filter(
        (item: any) => item?.[entityKey] !== e.recordKey,
      );
      setCheckedEntities(checkedEntitiesTemp);
    }
  };

  return (
    <>
      {!gamesAllList?.length ? (
        <div className="dbi-table-no-data dbi-left-cell">
          <div>
            <div style={{ textAlign: 'center' }}>{noSearchResultTips}</div>
          </div>
        </div>
      ) : (
        <SourceTable
          hideHeader={true}
          entityKey={entityKey}
          records={[...gamesAllList]}
          value={checkedEntitiesKeys}
          onChange={handleCheckedEntitiesKeysChange}
          handleLoadMore={handleLoadMore}
          isMoreLoading={isMoreLoading}
          entityType={entityType}
          entityRenderer={entityRenderer}
          showEntity={showEntity}
          hasShortCut={hasShortCut}
          isDisabled={isDisabled}
          disabledMsg={disabledMsg}
          chooseUpNum={chooseUpNum}
          setCheckedEntities={setCheckedEntities}
          checkedEntities={checkedEntities}
        />
      )}
      {true && <Loading classNameValue="dbi-sourcetable-loading" />}
    </>
  );
}
